import React from 'react';
import { connect } from 'react-redux';
import MenuItemQuantitySelection from './MenuItemQuantitySelection';
import { cartAddItem } from '../../../actions/cart';
// import Success from '../../../assets/svg/Success';
import success from '../../../assets/images/success.svg';


class MenuItemAdded extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addedItem: {
                itemAddons: []
            },
            quantities: [],
            statuses: []
        };
    }

    componentDidUpdate(prevProps, prevState) {

        let quantities = [];
        let statuses = [];
        if ((!prevProps.item && this.props.item.id) || prevProps.item.id != this.props.item.id) {

            // get the initial quantities and statuses
            if (this.props.item.itemAddons) {
                this.props.item.itemAddons.forEach((theAddon) => {
                    quantities.push(1);
                    statuses.push('ready');
                });
            }
            
            this.setState(() => ({
                quantities,
                statuses
            }));
        }
    }

    componentDidMount() {

        const theItem = this.props.item;
        let quantities = [];
        let statuses = [];
        if (theItem) {

            // get the initial quantities and statuses
            const theParsedItem = theItem;
            if (theParsedItem.itemAddons) {
                theParsedItem.itemAddons.forEach((theAddon) => {
                    quantities.push(1);
                    statuses.push('ready');
                });
            }
            
            this.setState(() => ({
                addedItem: theParsedItem,
                quantities,
                statuses
            }));
        }
    }

    subtractQuantity(index) {
        this.setState((prevState) => ({
            quantities: prevState.quantities.map((quantity, qIndex) => {
                if (qIndex == index && quantity > 1) {
                    return quantity - 1;
                }
                else {
                    return quantity;
                }
            })
        }));
    }

    addQuantity(index) {
        this.setState((prevState) => ({
            quantities: prevState.quantities.map((quantity, qIndex) => {
                if (qIndex == index) {
                    return quantity + 1;
                }
                else {
                    return quantity;
                }
            })
        }));
    }

    addAddon(index) {

        let theAddon = {
            ...this.props.item.itemAddons[index],
            quantity: this.state.quantities[index]
        };

        this.props.dispatch(cartAddItem("addon", {
            ...theAddon,
            total_item_price: (theAddon.quantity*theAddon.price).toFixed(2)
        }));

        this.setState((prevState) => ({
            statuses: prevState.statuses.map((status, qIndex) => {
                if (qIndex == index) {
                    return 'added';
                }
                else {
                    return status;
                }
            })
        }));
    }
    
    renderAddonSelection(addonIndex) {
        if (this.state.statuses[addonIndex] == "loading") {
            // return <LoadingSpinner />
            return (
                <p className="added-text">
                    Loading...
                </p> 
            );
        }
        else if (this.state.statuses[addonIndex] == "added") {
            return (

                <div className="print-added-container">
                    <div>

                    </div>
                    <div className="print-added-text">
                        Added!
                    </div>
               
                </div>
            );
        }
        else {
            return (


                <div className="print-individual-addon-container">
                        <div className="quantity-wrapper">
                            <MenuItemQuantitySelection
                                quantity={this.state.quantities[addonIndex]}
                                quantitySubtract={() => { this.subtractQuantity(addonIndex); }}
                                quantityAdd={() => { this.addQuantity(addonIndex); }}
                            />
                        </div>
                     
                        {/* */}
                        <div className="green-add-addon-button"
                        
                        onClick={() => {
                            this.addAddon(addonIndex);
                        }}

                        >
                            <div
                            className="a-green-addon-button"
                               
                            >
                                Add
                            </div>
                        </div>
                         
                </div>

              
            );
        }
    }

    printAvailableAddons() {
        if (this.props.item.itemAddons && this.props.item.itemAddons.length > 0) {
            return (
                <div>
                    {this.props.item.itemAddons.map((theAddon, index) => {
                        return (
                           
                               <div className="menu-quantity-row-wrapper" key={theAddon.id}>
                                   <div className="add-quantity-name">
                                        {theAddon.name}
                                    </div>
                                    {this.renderAddonSelection(index)}
                               </div>
                            
                        );
                    })}
                </div>
            );
        }
    }

    render() {

        return (

            <div>
                <div className="modalScroll">
                    <div className="success-wrapper">
                        <div className="success-circle" >
                            <img src={success} className="success-circle-image" />
                            
                        </div>
                        <div className="success-message-window">
                            <div className="text-window">
                                <p>{ this.props.item.name } has been added to the cart!</p>
                                <p className="subcheckout-label">Your item has been added to the cart! Would you like to add more
                                    items or checkout?
                                </p>
                            </div>
                        </div>

                        <div className="addon-container-top-padding">
                            {this.printAvailableAddons()}
                        </div>
                        <div className="fixed-wrapper-for-add-to-order ">
                            {/* Keep Ordering */}
                            <div className="add-to-order keep-order-button"
                              onClick={this.props.handleClose}
                            >
                                <div className="menu-item-added-button-text">Keep Ordering</div>
                            </div>

                            {/* Checkout */}
                            <div className="add-to-order checkout-button"
                              onClick={this.props.handleCart}
                            >
                                <div className="menu-item-added-button-text">Checkout</div>
                            </div>
                        </div>
                    </div>
               </div>


            

              
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        cart: state.cart
    };
};

export default connect(mapStateToProps)(MenuItemAdded);
